import 'slick-carousel'

var leaving_popop_link = ''

/* if you need sticky header */
const body = document.body;
let lastScroll = 0;
$(window).scroll(function() {
    scrollfunction();
});
scrollfunction();
function scrollfunction(){
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 120) {
        body.classList.remove('is-sticky-mode');
        return;
    }else
        body.classList.add('is-sticky-mode');
    lastScroll = currentScroll;
}
/* sticky menus end */

//smooth scroll
$('.anchor').click(function(e){
    e.preventDefault();
    const to_anchor = $(this).attr('href');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(to_anchor).offset().top
    }, 1000);
});

$('a.disabled').on('click', function(e){
    e.preventDefault()
})

const visible_page = $('.gform_page:visible').index()
let gform_current_page = 0
if(visible_page){
    gform_current_page = 1+parseInt(visible_page)

    const popup_pages = [27,28]

    if(popup_pages.includes(gform_current_page)){
        $('.lb-blue-backdrop').show()

        const close_btn = '<button id="lb-close-confirm-dialog" onclick="history.back();" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="29.182" height="29.182" viewBox="0 0 29.182 29.182"><g transform="translate(-1427.939 -878.879)"><path d="M3480,5730.879l24.939-24.939" transform="translate(-2049.94 -4824.939)" fill="none" stroke="#464341" stroke-linecap="round" stroke-width="3"/><path d="M0,24.939,24.939,0" transform="translate(1430.061 905.939) rotate(-90)" fill="none" stroke="#464341" stroke-linecap="round" stroke-width="3"/></g></svg></button>';

        $('#gform_page_1_'+gform_current_page).append(close_btn)
        body.classList.add('overflow-hidden')

        if(gform_current_page === 27){
            //set current date and readonly
            const date = new Date()
            const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
                .toISOString()
                .split("T")[0]
            $('#input_1_68').prop('readonly', true).val(dateString)
        }

    }
}

function isExternalLink(link){
    return (link.startsWith('http') && link.indexOf(window.location.host) === -1) &&
        (
            !link.startsWith("#") ||
            !link.startsWith("/") ||
            !link.startsWith("mailto:") ||
            !link.startsWith("tel:")
        )
}

$(document).on('click', "a", function(e){
    const link = $(this).attr("href")
    const isExternal = isExternalLink(link)

    if(isExternal) {
        e.preventDefault();
        leaving_popop_link = link
        showLeavingPopup()
    }
});

function showLeavingPopup(){
    $('#leaving-popup, .lb-blue-backdrop').show()
    body.classList.add('overflow-hidden')
    $("#confirm_leaving").on("click", onConfirmBtn)
    $("#cancel_leaving").on("click", hideLeavingPopup)
}
function hideLeavingPopup(){
    leaving_popop_link = ''
    $('#leaving-popup, .lb-blue-backdrop').hide()
    body.classList.remove('overflow-hidden')
    $("#confirm_leaving").off("click", onConfirmBtn)
    $("#cancel_leaving").off("click", hideLeavingPopup)
}

// Define the event listener for the Confirm button
function onConfirmBtn() {
    //open in new tab
    window.open(leaving_popop_link, "_blank")
    hideLeavingPopup()
}

const files_slick_settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    dots: true,
    mobileFirst: true,
    infinite: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="34.828" height="27.657" viewBox="0 0 34.828 27.657"><g transform="translate(1607.828 3189.828) rotate(180)"><line x2="30" transform="translate(1575 3176)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/><line x2="11" y2="11" transform="translate(1594 3165)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/><line x1="11" y2="11" transform="translate(1594 3176)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/></g></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="34.828" height="27.657" viewBox="0 0 34.828 27.657"><g transform="translate(-1573 -3162.172)"><line x2="30" transform="translate(1575 3176)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/><line x2="11" y2="11" transform="translate(1594 3165)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/><line x1="11" y2="11" transform="translate(1594 3176)" fill="none" stroke="#071b6c" stroke-linecap="round" stroke-width="4"/></g></svg></button>',
    responsive: [
        {
            breakpoint: 700,
            settings: "unslick"
        }
    ]
}

const files_slick = $('.grid-files').slick(files_slick_settings)
$(window).on('resize', () => {
    if( window.innerWidth <= 700 && !files_slick.hasClass('slick-initialized')) {
        $('.grid-files').slick(files_slick_settings);
    }
});

//we want the numbers to be the same has the question numbers
if($('.gf_progressbar_title').length){
    const c = $('.gf_step_current_page')
    const t = $('.gf_step_page_count')
    const current = parseInt(c.text())
    const total = parseInt(t.text())
    
    c.text(current-1) //removes first page
    t.text(total-3) //removes 2 (first, and 2 popups page)
}

//final popup, disable submit button if consent is not checked
var consent_input = $('#input_1_75_1')
var form_button = $('#gform_submit_button_1')
if(!consent_input.prop('checked'))
    form_button.prop('disabled', true)
consent_input.on('change', function(){
    form_button.prop('disabled', !$(this).prop('checked'))
})